import React from 'react';
import { motion } from 'framer-motion';
import CountUp from 'react-countup';
import { Star, Award, ThumbsUp } from 'lucide-react';

const TrustBar = () => {
  return (
    <section className="relative z-20 px-4 sm:px-6 lg:px-8 pb-12">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: false }}
        transition={{ duration: 0.6 }}
        className="max-w-4xl mx-auto -mt-16"
      >
        <div 
          className="rounded-xl border border-[#EFCD86]/15 p-3 md:p-4 lg:p-5 flex flex-col md:flex-row items-center justify-between gap-4 md:gap-6 shadow-xl"
          style={{ 
            background: 'rgba(13, 31, 51, 0.9)',
            backdropFilter: 'blur(12px)',
          }}
        >
          {/* Left - Rating */}
          <div className="flex flex-col items-center md:items-start text-center md:text-left">
            <div className="flex items-center gap-1 mb-1">
              {[1, 2, 3, 4, 5].map((star) => (
                <Star 
                  key={star} 
                  size={14} 
                  fill="#EFCD86" 
                  color="#EFCD86" 
                />
              ))}
              <span className="text-[#EFCD86] text-xs md:text-sm font-semibold ml-2">4.9/5</span>
            </div>
            <div className="text-2xl md:text-3xl font-bold text-white">
              <CountUp end={500} duration={2.5} separator="," />+
            </div>
            <span className="text-gray-400 text-xs md:text-sm">Businesses Served</span>
          </div>

          {/* Divider */}
          <div className="hidden md:block w-px h-12 bg-[#EFCD86]/20" />
          <div className="md:hidden w-full h-px bg-[#EFCD86]/20" />

          {/* Right - Trust Logos */}
          <div className="flex items-center justify-center gap-3 md:gap-6 lg:gap-8 flex-wrap">
            <div className="flex items-center gap-1 md:gap-2 text-gray-300 hover:text-white transition-colors cursor-pointer">
              <ThumbsUp size={20} className="text-[#67B253]" />
              <span className="font-semibold text-sm md:text-base lg:text-lg hidden sm:inline">Trustpilot</span>
            </div>

            <div className="flex items-center gap-1 md:gap-2 text-gray-300 hover:text-white transition-colors cursor-pointer">
              <Award size={20} className="text-[#046A8C]" />
              <span className="font-semibold text-sm md:text-base lg:text-lg hidden sm:inline">Capterra</span>
            </div>

            <div className="flex items-center gap-1 md:gap-2 text-gray-300 hover:text-white transition-colors cursor-pointer">
              <div className="w-5 h-5 md:w-6 md:h-6 rounded-full bg-[#EFCD86] flex items-center justify-center text-[#0a1628] font-bold text-xs md:text-sm">G</div>
              <span className="font-semibold text-sm md:text-base lg:text-lg hidden sm:inline">G2</span>
            </div>
          </div>
        </div>
      </motion.div>
    </section>
  );
};

export default TrustBar;
